import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=51d685ca&scoped=true&"
import script from "./Ranking.vue?vue&type=script&lang=ts&"
export * from "./Ranking.vue?vue&type=script&lang=ts&"
import style0 from "./Ranking.vue?vue&type=style&index=0&id=51d685ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d685ca",
  null
  
)

export default component.exports